import PriceWrapper from "./price-wrapper";
import Price from "./price";
import PropTypes from "prop-types";

const MoleculePrice = ({ className, currencyCode, amount, showDecimal, priceTitle }) => {
  if (!amount || !priceTitle) {
    return;
  }

  return (
    <PriceWrapper text={priceTitle} className={className}>
      <Price
        amount={amount}
        currencyCode={currencyCode}
        currencyCodeClassName="hidden @[275px]/label:inline"
        showDecimal={showDecimal || false}
      />
    </PriceWrapper>
  );
};

MoleculePrice.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  className: PropTypes.string,
  currencyCode: PropTypes.string.isRequired,
  priceTitle: PropTypes.string.isRequired,
  showDecimal: PropTypes.bool,
};

export default MoleculePrice;
